<template>
  <div class="translate-tool">
    <Poptip v-model="visible" word-wrap placement="top-start">
      <Icon :color="translate ? '#2d8cf0' : ''" custom="icon-custom_translate" size="24" />
        <div class="lang-wrap" slot="content">
                <div class="lang-item" :class="item.value == translate ? 'active' : ''" style="padding: 5px 0px; cursor: pointer;" v-for="(item, index) in langList" :key="index">
                  <span @click="setTranslate(item.value)" >{{item.name}}</span>
                
                </div>
              
        </div>
    </Poptip>
  </div>
</template>
<script>
import conf from "@/views/im/conf";

export default {
  name: "faces",
  components: {},
  computed: {
    translate: {
      get: function () {
        return this.$store.state.translate;
      }
    },
  },
  data() {
    return {
      langList: [
        {'name': '菲律宾语', 'value': 'fil'},
        {'name': '泰语', 'value': 'th'},
        {'name': '英语', 'value': 'en'},
        {'name': '关闭', 'value': ''},
      ],
      keyword: '',
      tempList: [],
      visible: false
    };
  },
  methods: {
    /**
     * 切换语言
     */
    setTranslate(value)
    {
      this.$store.commit('setTranslate', value);
      this.visible = false;
      this.$store.commit(conf.platform+"/getTransMessage");
    }
  }
};
</script>

<style scoped lang="scss">

.translate-tool {
  display: inline-block;
  .lang-wrap {
    .active {
      color: #2d8cf0;
    }
  }
}
</style>
